import { render, staticRenderFns } from "./MemberIdentityVerificationInfo.vue?vue&type=template&id=0114c08a&scoped=true"
import script from "./MemberIdentityVerificationInfo.vue?vue&type=script&lang=js"
export * from "./MemberIdentityVerificationInfo.vue?vue&type=script&lang=js"
import style0 from "./MemberIdentityVerificationInfo.vue?vue&type=style&index=0&id=0114c08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0114c08a",
  null
  
)

export default component.exports